import { render, staticRenderFns } from "./AttachedToPositionsTab.vue?vue&type=template&id=6e6fd0e6&scoped=true"
import script from "./AttachedToPositionsTab.vue?vue&type=script&lang=js"
export * from "./AttachedToPositionsTab.vue?vue&type=script&lang=js"
import style0 from "./AttachedToPositionsTab.vue?vue&type=style&index=0&id=6e6fd0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6fd0e6",
  null
  
)

export default component.exports